import {
  GET_OCCUPATION,
  GET_REPORTER_TYPE,
  GET_INTERMEDIATORY,
  GET_CONTACT_SOURCE,
  ADD_PRIMARY_CASE,
  GET_PRIMARY_QUERY,
  GET_PRIMARY_REPORTED,
  UPDATE_CASE_REPORTER_INFO,
  UPDATE_CASE_QUERY,
  GET_LITERATURE,
  UPDATE_LITERATURE,
  REPORTER_IS_PRIMARY,
} from '../../types'

const INITIAL_STATE = {
  allOccuption: [],
  allReporter: [],
  addPrimary: [],
  allIntermediatory: [],
  allPrimaryReported: [],
  allPrimaryQuery: [],
  allContactSource: [],
  updatePrimaryInfo: [],
  updateQuery: [],
  allLiterature: [],
  updateLiterature: [],
  isPrimary: null
}

const primaryCaseReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_OCCUPATION:
      return {
        ...state,
        allOccuption: payload,
      }
    case GET_REPORTER_TYPE:
      return {
        ...state,
        allReporter: payload,
      }
    case GET_INTERMEDIATORY:
      return {
        ...state,
        allIntermediatory: payload,
      }

    case GET_CONTACT_SOURCE:
      return {
        ...state,
        allContactSource: payload,
      }
    case ADD_PRIMARY_CASE:
      return {
        ...state,
        addPrimary: payload,
      }
    case GET_PRIMARY_REPORTED:
      return {
        ...state,
        allPrimaryReported: payload,
      }
    case GET_PRIMARY_QUERY:
      return {
        ...state,
        allPrimaryQuery: payload,
      }
    case UPDATE_CASE_REPORTER_INFO:
      return {
        ...state,
        updatePrimaryInfo: payload,
      }

    case UPDATE_CASE_QUERY:
      return {
        ...state,
        updateQuery: payload,
      }
    case GET_LITERATURE:
      return {
        ...state,
        allLiterature: payload,
      }
    case UPDATE_LITERATURE:
      return {
        ...state,
        updateLiterature: payload,
      }
    case REPORTER_IS_PRIMARY:
      return {
        ...state,
        isPrimary: payload,
      }
    default:
      return state
  }
}

export default primaryCaseReducer
